module.exports = __webpack_public_path__ + "static/media/logo_color.7fd88eb8.svg";